import { FreeTrial } from '@mc/api'
import { Trans, useTranslation } from '@mc/i18n'
import classes from './Hero.module.scss'

export const HeroTitle = ({ guestPass }: { guestPass: FreeTrial }) => {
  const { t } = useTranslation('@mc/next')

  return (
    <h1
      className={`${classes.title} mc-text--center mc-text--uppercase mc-text--brand mc-overflow--hidden mc-px-4`}
      aria-label={t('guestPassRecipient.hero.a11y.title', {
        guestPassDays: guestPass?.durationDays,
      })}
    >
      <Trans
        i18nKey='guestPassRecipient.hero.title'
        ns='@mc/next'
        values={{ guestPassDays: guestPass?.durationDays }}
      >
        <span className='mc-text-color--primary' />
      </Trans>
    </h1>
  )
}
